module.exports = __webpack_public_path__ + "img/sophia-header.85336a46.svg";